import type { BetSlipItem, FobPropositionSelection, RaceDetails } from '@mobi/betslip/types'
import {
  isFobDetails,
  isFobMatchedSelection,
  isFobPropositionSelection,
  isRaceDetails,
  isSameRaceMultiSelection,
  isStartingPriceMatchedSelection,
  isToteSelection,
} from '@mobi/betslip/helpers/typeGuards'
import { getPlanSequenceFromSelection } from '@mobi/betslip/helpers/getPlanSequence'
import type { BetDetails, FOOBetDetails, LoadBetDetails } from '@core/Areas/ShareBet/LoadBet/types'
import { formatFixtureDateToSimpleString } from '@core/Areas/Racing/helpers/formatFixtureDateToSimpleString'

export const createBetSlipLoadBetDetails = (
  item: BetSlipItem,
  isMulti?: boolean
): LoadBetDetails | null => {
  const planSeq = getPlanSequenceFromSelection(item.selection)

  if (isFobPropositionSelection(item.selection) && isFobDetails(item.selectionDetails)) {
    let betType = item.selectionDetails.marketName
    if (isMulti) betType = item.multiLegBetType === 'P' ? 'Place - Fixed' : 'Win - Fixed'

    const fooBetDetails: FOOBetDetails = {
      betType,
      competitionName: item.selectionDetails.competitionName as string,
      competitionSeq: item.selectionDetails.event.toString(),
      propositionSeq: +item.selection.propositionSeq,
      sportName: item.selectionDetails.sportName as string,
      eventStartDateTime: item.selectionDetails.eventStartTime.toString(),
    }
    return fooBetDetails
  }

  if (isToteSelection(item.selection) && isRaceDetails(item.selectionDetails)) {
    const selectionString = item.selection.selectionString
    const numberOfCombinations = item.selection.numberOfCombinations

    const toteBetDetails: BetDetails = {
      fixtureId: item.selectionDetails.races[0].meetingId,
      fixtureDate: formatFixtureDateToSimpleString(item.selection.fixtureDate),
      races:
        item.selectionDetails.races.length === 1
          ? [item.selectionDetails.races[0].raceNumber]
          : item.selectionDetails.races.map(race => race.raceNumber),
      selectionString,
      planSeq,
      numberOfCombinations,
      betType: item.selection.betType,
    }
    return toteBetDetails
  }

  if (isSameRaceMultiSelection(item.selection) && isRaceDetails(item.selectionDetails)) {
    const srmBetDetails: BetDetails = {
      fixtureId: item.selection.fixtureId,
      fixtureDate: formatFixtureDateToSimpleString(item.selection.fixtureDate),
      races: [(item.selectionDetails as RaceDetails).races[0].raceNumber],
      selectionString: item.selection.acceptors[0].acceptorNumber.toString(),
      planSeq,
      betType: 'Win - Fixed',
      srmSelections: item.selection.acceptors,
    }

    return srmBetDetails
  }

  if (
    (isFobMatchedSelection(item.selection) || isStartingPriceMatchedSelection(item.selection)) &&
    isRaceDetails(item.selectionDetails)
  ) {
    const selectionString = item.selection.acceptorNumber.toString()
    const numberOfCombinations = 1
    let betType = `${(item.selection as FobPropositionSelection).marketCode || 'Win & Place'} - Fixed`
    if (isMulti) betType = item.multiLegBetType === 'P' ? 'Place - Fixed' : 'Win - Fixed'

    const fixedMatchedBetDetails: BetDetails = {
      fixtureId: item.selectionDetails.races[0].meetingId,
      fixtureDate: formatFixtureDateToSimpleString(item.selection.fixtureDate),
      races: [item.selectionDetails.races[0].raceNumber],
      selectionString,
      planSeq,
      numberOfCombinations,
      betType,
    }
    return fixedMatchedBetDetails
  }

  return null
}
